(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          var swiper = new Swiper(".alsolikeSwipers", {
           
            watchSlidesProgress: true,
            mousewheel: {
              forceToAxis: true,
            },
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev", 
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            scrollbar: {
              el: '.swiper-scrollbar',
            }, 
            breakpoints: {
              300: {  //当屏幕宽度大于等于320
                slidesPerView: 1,
                spaceBetween: 10 
              },
              768: {  //当屏幕宽度大于等于768 
                  slidesPerView: 1.5,
                  spaceBetween: 20
              },
              1280: {  //当屏幕宽度大于等于1280
                  slidesPerView: 2.5,
                  spaceBetween: 20,
              }
            } 
          });

          function updateSelectedValuesInURL() {
            var selectedValues = [];
            var imgArr = [];
    
            $('input[name="compare"]:checked').each(function() {
              selectedValues.push($(this).val());
              var imgSrc = $(this).parents(".product_indexItem").find(".product_item_indexImg:eq(0) img").attr("src");
              imgArr.push(imgSrc);
            });
            renderImages();
            var params = new URLSearchParams(window.location.search);
            params.set('compare', selectedValues.join(','));
            window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
          }
          function renderImages (){ 
            var selectedValues = [];
            var imgArr = [];
    
            $('input[name="compare"]:checked').each(function() {
              selectedValues.push($(this).val());
              var imgSrc = $(this).parents(".product_indexItem").find(".product_item_indexImg:eq(0) img").attr("src");
              imgArr.push(imgSrc);
            });
              // 将 imgArr 存储到 localStorage
              localStorage.setItem('imgArr', JSON.stringify(imgArr));
    
              // 从 localStorage 获取存储的 imgArr
              var imgArrString = localStorage.getItem('imgArr');
      
              // 如果存在存储的数据，则将其解析为数组
              if (imgArrString) {
                var imgArr = JSON.parse(imgArrString);
      
                // 获取目标 <div> 元素
                var targetDiv = document.querySelector('.imgList');
      
                // 清空目标 <div> 的内容
                targetDiv.innerHTML = '';
      
                // 然后将 <img> 放入 <div>，最后将 <div> 放入目标 <div>
                imgArr.forEach(function(imgSrc, index) {
                  var imgBox = document.createElement('div');
                  imgBox.classList.add('imgBox'); // 添加 imgBox 类名
                
                  // 创建一个具有类 'imgBox_cha' 的新 div
                  var imgBoxCha = document.createElement('div');
                  imgBoxCha.innerHTML = "x";
                  imgBoxCha.classList.add('imgBox_cha');
                
                  // 将 imgSrc 存储在 imgBoxCha 的数据属性中
                  imgBoxCha.dataset.imgSrc = imgSrc;
                
                  // Assuming selectedValues is an array of selected values
                  imgBox.dataset.selectedValue = selectedValues[index];
                
                  imgBox.appendChild(imgBoxCha); // 将 imgBoxCha 放入 imgBox 中
                
                  var imgElement = document.createElement('img');
                  imgElement.src = imgSrc;
                  imgBox.appendChild(imgElement);
                
                  targetDiv.appendChild(imgBox);
                });
      
                // 在图像渲染后附加到 .imgBox_cha 的点击事件
                $(".imgBox_cha").click(function() {
                    // 获取被点击的 .imgBox_cha 的 imgSrc
                    var clickedValueId = $(this).parent('.imgBox').data('selectedValue');
                    console.log("Clicked Value ID:", clickedValueId);
      
                    // 删除被点击的 .imgBox_cha 的父元素 .imgBox
                    $(this).parent('.imgBox').remove();
      
                    // 找到对应的 input 元素并触发点击事件
                    $('input[name="compare"][value="' + clickedValueId + '"]').trigger('click');
      
                    var params = new URLSearchParams(window.location.search);
                    params.set('compare', newArry.join(','));
                    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
                    
                });
      
          
      
      
              
      
              }
            
          }
             // fixed nav
            // 检查 URL 参数中已选择的数量
            function getSelectedCountFromURL() {
              var params = new URLSearchParams(window.location.search);
              var selectedValues = params.get('compare');
              if (selectedValues) {
                renderImages();
                return selectedValues.split(',').length;
              }
              return 0;
            }
          
            // 清除所有选中并清除 URL 参数
            function clearAll() {
              $('input[name="compare"]').prop('checked', false);
              var params = new URLSearchParams(window.location.search);
              params.delete('compare');
              window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
              updateSelectedCount();
              isopenNav();
            }
            function initialize() {
              var params = new URLSearchParams(window.location.search);
              var selectedValues = params.get('compare');
              if (selectedValues) {
                var selectedArray = selectedValues.split(',');
                $('input[name="compare"]').each(function() {
                  $(this).prop('checked', selectedArray.includes($(this).val()));
                });
              }
              limitSelection();
              updateSelectedCount();
              isopenNav();
            }
            // 限制最多只能选择三个选项
            function limitSelection() {
              var selectedCount = getSelectedCountFromURL();
              $('input[name="compare"]').each(function() {
                let widthSize = document.documentElement.clientWidth;
                if(widthSize<=740){
                  if (selectedCount >= 2 && !$(this).is(':checked')) {
                    $(this).prop('disabled', true);
                    $(this).closest('.bike-compare-checkbox').addClass('disabled');
                  } else {
                    $(this).prop('disabled', false);
                    $(this).closest('.bike-compare-checkbox').removeClass('disabled');
                  }
                
                }else{
                  if (selectedCount >= 3 && !$(this).is(':checked')) {
                    $(this).prop('disabled', true);
                    $(this).closest('.bike-compare-checkbox').addClass('disabled');
                  } else {
                    $(this).prop('disabled', false);
                    $(this).closest('.bike-compare-checkbox').removeClass('disabled');
                  }
                }
              });
            }
              // 根据 URL 参数中的值来显示或隐藏比较导航栏
              function isopenNav() {
              var params = new URLSearchParams(window.location.search);
              var selectedValues = params.get('compare');
              if (selectedValues && selectedValues.split(',').length > 0) {
                $('#compare-nav').slideDown();
              } else {
                $('#compare-nav').slideUp();
              }
            }
          
            // 更新已选择的数量
            function updateSelectedCount() {
              var selectedCount = getSelectedCountFromURL();
              $('.selected-count').text(selectedCount + ' selected');
            }

  
            
          // Example: Execute the function when a button with the class 'compare-button' is clicked
          $('.bike-compare-checkbox').on('click', function() {
            updateSelectedValuesInURL();
            limitSelection();
            updateSelectedCount();
            isopenNav();
          });


          $('.start-comparison').on('click', function(e) {
            // 获取地址栏中的参数
            var params = new URLSearchParams(window.location.search);
            var compareValues = params.get('compare');
      
            // 构建新的页面 URL，将 compare 参数添加到其中
            var compareURL = `{{section.settings.compare_link}}` + '?compare=' + compareValues;
            console.log(compareURL);
            // 在 JavaScript 中进行页面跳转
            window.location.href = compareURL;
          });
      
          // 点击 "Clear all" 按钮
          $('.clear-all').on('click', function() {
            clearAll();
            limitSelection();
          });

          initialize();

            
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
